import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_level_monitoring_algo_RowClass } from '../../../dbschema/bl_inv_stock_level_monitoring_algo.model';

export class StockLevelMonitoringModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_algo: bl_inv_stock_level_monitoring_algo_RowClass = new bl_inv_stock_level_monitoring_algo_RowClass();
}
